import { ContestManager } from "../data/ContestManager";
import { Templates } from "../ui/Templates";
import { leaderboardItem } from "../ui/templates/songMenuTemplates";

export class _LeadersSection {
	private _container:HTMLDivElement;
	private _leadersListDiv:HTMLDivElement;
	
	private _thisWeekDescription:HTMLDivElement;
	private _lastWeekDescription:HTMLDivElement;
	
	constructor(container:HTMLDivElement){
		this._container = container;
		this._init();
	}
	
	private _init():void {
		this._thisWeekDescription = this._container.querySelector(
			".m-leaders-description-this-week");
		this._lastWeekDescription = this._container.querySelector(
			".m-leaders-description-last-week");
		
		this._thisWeekDescription.querySelector("a").addEventListener("click",
			this._toggleWeek);
		this._lastWeekDescription.querySelector("a").addEventListener("click",
			this._toggleWeek);
			
		this._leadersListDiv = this._container.querySelector(".m-leaders-list");
	}
	
	public async update(weekIndex:number = 0):Promise<void> {
		//get the latest contest data
		let dateId:string = ContestManager.getCompetitionId(null, weekIndex);
		await ContestManager.getEntries(dateId);
		
		this._populateLeaders();
	}
	
	private _populateLeaders():void {
		//sort by highest score
		ContestManager.entries.sort((e1, e2) => {
			return (e1.points >= e2.points)? -1 : 1;
		});
		
		//populate leaderboard
		while (this._leadersListDiv.children.length > 0){
			this._leadersListDiv.children[0].remove();
		}
		ContestManager.entries.forEach((e) => {
			let li = Templates.createDiv(leaderboardItem);
			li.innerHTML = `${e.points} pts - ${e.team.name}`;
			this._leadersListDiv.append(li);
		});
	}
	
	private _toggleWeek = (e:MouseEvent):void => {
		if (this._lastWeekDescription.classList.contains("hide")){
			this._lastWeekDescription.classList.remove("hide");
			this._thisWeekDescription.classList.add("hide");
			this.update(1);
		}
		else {
			this._thisWeekDescription.classList.remove("hide");
			this._lastWeekDescription.classList.add("hide");
			this.update(0);
		}
	}
}